/**
 * Centralized route constants for the hub-v2 app.
 * Use these instead of hardcoding route strings throughout the codebase.
 */
export const ROUTES = {
  HOME: "/",
  CAMPAIGNS: "/campaigns",
  TRADE: "/trade",
  HOLD: "/hold",
  QUESTS: "/quests",
  LOTTERY: "/lottery",
  PORTFOLIO: "/portfolio",
  PROFILE: "/profile",
  PREDICTIONS: "/predictions",
  HALL_OF_FAME: "/hall-of-fame",
  CLICK_AND_EARN: "/click-and-earn",
  COOKIES: "/cookies",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  KRAKEN: "/kraken",
  COINBASE: "/coinbase",
  LBANK: "/lbank",
  CEDE_ARENA: "/cede-arena",

  // Standalone pages (no sidebar for some pages, no onboarding, no splash modals)
  LAUNCH: "/launch",
  /** Served by proxy.ts to visitors in a blocked region. */
  REGION_BLOCKED: "/region-blocked",
  CRYPTO_COM_SIGNUP: "/crypto-com-signup",
} as const;

/** Route prefixes for standalone pages that don't render full app chrome. */
export const STANDALONE_PREFIXES = [ROUTES.LAUNCH, ROUTES.CRYPTO_COM_SIGNUP] as const;
